export default __webpack_public_path__ + "static/media/grid-col-3.705e769a.svg";